import React, { useId } from 'react';
import clsx from 'clsx';
import BlueGreenSquare from '../Form/VacStateSvg/BlueGreenSquare';
import GreenSquare from '../Form/VacStateSvg/GreenSquare';
import BlueSquare from '../Form/VacStateSvg/BlueSquare';
import OrangeSquare from '../Form/VacStateSvg/OrangeSquare';
import GreenTriangle from '../Form/VacStateSvg/GreenTriangle';
import { Tooltip } from 'react-tooltip';
import BlueCross from '../Form/VacStateSvg/BlueCross';

import { YellowCircle } from '../Form/VacStateSvg/YellowCircle';
import OrangeCircle from '../Form/VacStateSvg/OrangeCircle';
import YellowSquare from '../Form/VacStateSvg/YellowSquare';
import GreenCircle from '../Form/VacStateSvg/GreenCircle';
export default function VacancyStatus({ type = 'accepted_by_employer' }) {
  const id = useId();
  const vacancyTypes = {
    // reset_by_staff: {
    //   text: 'Вакансия создана Менеджером/Администратором, отредактирована контрагентом',
    //   element: <BlueCross />,
    // },
    created_by_employer: {
      text: 'Вакансия создана Контрагентом',
      element: <YellowCircle />,
    },
    created_by_staff_edited_by_employer: {
      text: 'Вакансия создана Менеджером/Администратором, отредактирована контрагентом',
      element: <OrangeCircle />,
    },
    approved_by_manager: {
      text: 'Вакансия согласована Менеджером/Администратором',
      element: <GreenSquare />,
    },
    approved: {
      text: 'Вакансия согласована Менеджером/Администратором',
      element: <GreenSquare />,
    },
    created_by_staff: {
      text: 'Вакансия создана Менеджером/Администратором',
      element: <YellowSquare />,
    },
    returned_back: {
      text: 'Вакансия создана Менеджером/Администратором',
      element: <YellowSquare />,
    },
    sent_to_employer: {
      text: 'Вакансия была отредактирована Администратором/Менеджером и отправлена на ознакомление Контрагенту',
      element: <BlueSquare />,
    },
    edited_by_employer: {
      text: 'Вакансия отредактирована Контрагентом',
      element: <OrangeCircle />,
    },
    edited_by_staff: {
      text: 'Вакансия отредактирована Менеджером/Администратором',
      element: <OrangeSquare />,
    },
    accepted_by_employer: {
      text: 'Изменения приняты контрагентом',
      element: <GreenCircle />,
    },
    // created_by_staff: {
    //   text: 'Вакансия создана Менеджером/Администратором',
    //   element: <GreenCircle />,
    // },
    // accepted_by_employer: {
    //   text: 'Изменения приняты контрагентом',
    //   element: <BlueSquare />,
    // },
    // {
    //   text: 'Согласовано Менеджером на размещение',
    //   element: <GreenCheckmark />,
    // },
    // {
    //   text: 'Вакансия не согласована, но произведены исправления Менеджером',
    //   element: <BlueCross />,
    // },
    // {
    //   text: 'Вакансия была редактирована, изменения сохранены, но была отменена и  вакансия осталась в блоке «на модерации»',
    //   element: <RedCross />,
    // },

    // {
    //   text: 'Вакансия была отредактирована Администратором/Менеджером и отправлена на ознакомление Контрагенту',
    //   element: <GreenSquare />,
    // },
    // {
    //   text: 'Вакансия создана на главной странице или деактивизирована Контрагентом или прекращена по сроку действий',
    //   element: <RedSquare />,
    // },
    // {
    //   text: 'Вакансия создана Менеджером/Администратором',
    //   element: <GreenCircle />,
    // },

    // {
    //   text: 'Вакансия создана Менеджером/Администратором',
    //   element: <OrangeCircle />,
    // },
  };
  const currentVacancyStatus = vacancyTypes?.[type] ? vacancyTypes?.[type] : null;
  return (
    <>
      {currentVacancyStatus ? (
        <>
          <p data-tooltip-id={id} data-tooltip-content={currentVacancyStatus?.text}>
            {currentVacancyStatus?.element}
          </p>
          <Tooltip id={id} className="z-[10000]" render={({ content }) => <div className="flex w-60">{content}</div>} />
        </>
      ) : (
        <div></div>
      )}
    </>
  );
}
